import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Box, TextField, Typography, ButtonProps } from '@mui/material'
import { useTranslation } from 'react-i18next'

import BasicModal from '@/components/UI/Dialog'
import { sendForgotPassword } from '../../../store/knowledge/actions'
import CopyIcon from '../../../components/UI/Common/CopyIcon'

type ForgotPasswordUser = {
  user_id: string
  show: boolean
  size?: 'sm' | 'lg' | 'xl'
  onHide: () => void
}

export default function ForgotPasswordModal(props: ForgotPasswordUser) {
  const { t } = useTranslation('translation')
  const dispatch = useDispatch()
  const [forgotPasswordUrl, setForgotPasswordUrl] = useState('')

  useEffect(() => {
    const getForgotPasswordUrl = async () => {
      const response: any = await dispatch(sendForgotPassword(props.user_id))
      if (response && response?.data?.reset_password_url) {
        setForgotPasswordUrl(response.data.reset_password_url)
      }
    }
    props.show && getForgotPasswordUrl()
  }, [props])

  const sendForgotPasswordEmail = async () => {
    await dispatch(sendForgotPassword(props.user_id, true))
    props.onHide()
  }

  const footerActions = [
    {
      title: t('Cancel'),
      variant: 'outlined' as const,
      color: 'primary' as ButtonProps['color'],
      onClick: props.onHide,
    },
    {
      title: t('Send Email'),
      variant: 'outlined' as const,
      color: 'error' as ButtonProps['color'],
      onClick: sendForgotPasswordEmail,
    },
  ]

  return (
    <BasicModal
      open={props.show}
      onClose={props.onHide}
      sx={{ width: props.size === 'lg' ? '600px' : '500px', height: 'auto' }}
      title={t('Forgot Password')}
      footerActions={footerActions}
    >
      <Box mt={2}>
        <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
          {t('Link to reset password')}
        </Typography>
        <Box sx={{ position: 'relative' }}>
          <TextField
            fullWidth
            value={forgotPasswordUrl}
            disabled
            size="small"
            sx={{
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: 'rgba(0, 0, 0, 0.6)',
              },
            }}
          />
          <Box sx={{ position: 'absolute', right: 8, top: 8 }}>
            <CopyIcon text={forgotPasswordUrl} />
          </Box>
        </Box>
      </Box>
    </BasicModal>
  )
}
